import {SEVERITY_MAP} from "models/options";

export const getIncidentPriorityScoreColor = (globalScore) => {
  if (globalScore > 799) {
    return {
      background: SEVERITY_MAP.Critical.bgColor,
      color: SEVERITY_MAP.Critical.color
    };
  } else if (globalScore > 599) {
    return {
      background: SEVERITY_MAP.High.bgColor,
      color: SEVERITY_MAP.High.color
    };
  } else if (globalScore > 399) {
    return {
      background: SEVERITY_MAP.Medium.bgColor,
      color: SEVERITY_MAP.Medium.color
    };
  } else {
    return {
      background: SEVERITY_MAP.Low.bgColor,
      color: SEVERITY_MAP.Low.color
    };
  }
};
